export const VIVACE = 'VIVACE';
export const BUBBLY = 'BUBBLY';
export const SIREN = 'SIREN';
export const TRIPLET = 'TRIPLET';
export const STACCATO = 'STACCATO';
export const CRESCENDO = 'CRESCENDO';
export const DISABLED = 'DISABLED';
